/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  /* --- Hero slideshow: re-measure after fonts and media settle --------------
     slider-component initialises Flickity immediately, so slide heights are
     measured while the fallback font is still rendering. The hero slide is
     taller than its 75vh minimum (the heading, subcopy and buttons exceed it),
     so the pre-font measurement is too tall -- measured 931px, settled 860px.
     Flickity writes that stale value onto .flickity-viewport as an inline
     height and never revisits it, so the viewport stays ~71px taller than the
     slide and the difference renders as a white band above the next section.

     Any resize makes Flickity re-measure, which is why the band disappears
     whenever devtools or the preview bar opens. This does the same thing
     deliberately, once the things that change text metrics have finished. */
  var remeasure = function () {
    window.dispatchEvent(new Event('resize'));
  };

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(remeasure);
  }

  if (document.readyState === 'complete') {
    remeasure();
  } else {
    window.addEventListener('load', remeasure, { once: true });
  }


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
